import type {JSONContent} from '@tiptap/vue-3'
import type {TiptapNs} from './types'

/** Storage-format helpers. */

/** The document Tiptap produces for an empty editor (trailingNode guarantee). */
export const EMPTY_TIPTAP_DOC: JSONContent = {
  type: 'doc',
  content: [{type: 'paragraph'}],
}

/** Düz metni Tiptap doc JSON string'ine çevirir (Faz 4.4. */
export const textToTiptapDoc = (
  text: string | null | undefined,
): string | undefined => {
  if (!text || !text.trim()) return undefined
  const content: JSONContent[] = text.split(/\r?\n/).map((line) =>
    line.trim()
      ? {type: 'paragraph', content: [{type: 'text', text: line}]}
      : {type: 'paragraph'},
  )
  return JSON.stringify({type: 'doc', content})
}

/** Decide what to feed Tiptap from a stored value. */
export const normalizeInitialContent = (
  raw: TiptapNs.Content,
): JSONContent | string => {
  if (raw == null || raw === '') return ''
  if (typeof raw === 'object') return raw

  const trimmed = raw.trim()
  if (trimmed.startsWith('{')) {
    try {
      const parsed = JSON.parse(trimmed)
      if (parsed && typeof parsed === 'object' && parsed.type === 'doc') {
        return parsed as JSONContent
      }
      return ''
    } catch {
      // fall through to HTML
    }
  }
  return raw
}
